// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawing-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Poster-shaped (2:3) drawing area, sized to fit both the width and the
     viewport height minus the room for instructions and controls. */
  width: 100%;
  max-width: min(100%, calc((100vh - 6.5rem) * 2 / 3));
  max-width: min(100%, calc((100dvh - 6.5rem) * 2 / 3));
  margin: 0 auto;
  aspect-ratio: 2 / 3;
  position: relative;
  /* Prevent scrolling on touch devices */
  touch-action: none;
  overflow: hidden;
}

.drawing-canvas {
  border: 2px solid #ccc;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: white;
  cursor: crosshair;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  /* Prevent scrolling and improve touch interaction */
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* Once submitted, the drawing is final: no more strokes. */
.drawing-canvas.locked {
  pointer-events: none;
  cursor: default;
}

.drawing-saving-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.82);
  text-align: center;
}

.drawing-saving-overlay p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.3rem;
  font-weight: bold;
}

.drawing-saving-spinner {
  width: 48px;
  height: 48px;
  border: 5px solid rgba(0, 0, 0, 0.15);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.drawing-controls {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/drawing-canvas.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;oEACkE;EAClE,WAAW;EACX,oDAAoD;EACpD,qDAAqD;EACrD,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oDAAoD;EACpD,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb","sourcesContent":[".drawing-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* Poster-shaped (2:3) drawing area, sized to fit both the width and the\n     viewport height minus the room for instructions and controls. */\n  width: 100%;\n  max-width: min(100%, calc((100vh - 6.5rem) * 2 / 3));\n  max-width: min(100%, calc((100dvh - 6.5rem) * 2 / 3));\n  margin: 0 auto;\n  aspect-ratio: 2 / 3;\n  position: relative;\n  /* Prevent scrolling on touch devices */\n  touch-action: none;\n  overflow: hidden;\n}\n\n.drawing-canvas {\n  border: 2px solid #ccc;\n  box-sizing: border-box;\n  border-radius: 8px;\n  background-color: white;\n  cursor: crosshair;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  /* Prevent scrolling and improve touch interaction */\n  touch-action: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n/* Once submitted, the drawing is final: no more strokes. */\n.drawing-canvas.locked {\n  pointer-events: none;\n  cursor: default;\n}\n\n.drawing-saving-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  box-sizing: border-box;\n  border-radius: 8px;\n  background-color: rgba(255, 255, 255, 0.82);\n  text-align: center;\n}\n\n.drawing-saving-overlay p {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.3rem;\n  font-weight: bold;\n}\n\n.drawing-saving-spinner {\n  width: 48px;\n  height: 48px;\n  border: 5px solid rgba(0, 0, 0, 0.15);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.drawing-controls {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
